<template>
  <div>
    <v-navigation-drawer :value="drawer" app @transitionend="ShowEvent">
      <IphLogo />
      <v-divider></v-divider>
      <AvatarUser v-if="GET_user" />

      <v-divider></v-divider>

      <v-list dense nav>
        <v-list-item link :to="{ name: 'home' }" color="red darken-2">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Página Inicial</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!-- <v-divider v-if="menuComunication"></v-divider>
        <v-list-group v-if="menuComunication" prepend-icon="mdi-image-size-select-actual" color="iphColor">
            <template dense v-slot:activator>
                <v-list-item dense class="ml-0 pl-0">
                    <v-list-item-title>Banners</v-list-item-title>
                </v-list-item>
            </template>

            <v-list dense nav sub-group class="ml-5 pl-5">
                <v-list-item-group  color="primary">
                <v-list-item link to="/" sub-group color="iphColor">
                    <v-list-item-icon>
                        <v-icon>mdi-image-multiple</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content >
                        <v-list-item-title >Todos</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>


                <v-list-item link to="/" sub-group>
                    <v-list-item-icon>
                        <v-icon>mdi-image-plus</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>Novo Banner</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
            </v-list>
        </v-list-group> -->

      <!-- <v-divider v-if="menuComunication"></v-divider>
        <v-list-group v-if="menuComunication" prepend-icon="mdi-newspaper">
            <template dense v-slot:activator>
                <v-list-item dense class="ml-0 pl-0">
                <v-list-item-title>Notícias</v-list-item-title>
                </v-list-item>
            </template>

            <v-list dense nav sub-group class="ml-5 pl-5">
                <v-list-item link to="/" sub-group>
                    <v-list-item-icon>
                        <v-icon>mdi-view-list</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>Todas as Notícia</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link to="/" sub-group>
                    <v-list-item-icon>
                        <v-icon>mdi-newspaper-plus</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>Nova Notícia</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-list-group>

        <v-divider></v-divider> -->

      <!-- <v-list-group prepend-icon="mdi-file-document">
            <template dense v-slot:activator>
                <v-list-item dense class="ml-0 pl-0">
                <v-list-item-title>Artigos</v-list-item-title>
                </v-list-item>
            </template>

            <v-list dense nav sub-group class="ml-5 pl-5">
                <v-list-item link to="/" sub-group>
                    <v-list-item-icon>
                        <v-icon>mdi-view-dashboard</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>Novo Artigo</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-list-group> -->

      <!-- <v-divider></v-divider>

        <v-list-group prepend-icon="mdi-teach">
            <template dense v-slot:activator>
                <v-list-item dense class="ml-0 pl-0">
                <v-list-item-title>Cursos</v-list-item-title>
                </v-list-item>
            </template>
            <v-list dense nav sub-group class="ml-5 pl-5">
                <v-list-item link to="/cursos" sub-group>
                    <v-list-item-icon>
                        <v-icon>mdi-notebook-multiple</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>Cursos</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link to="/cursos/criar" sub-group>
                    <v-list-item-icon>
                        <v-icon>mdi-book-plus-multiple</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>Novo Curso</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-list-group> -->

      <v-divider></v-divider>

      <v-list-group prepend-icon="mdi-account" color="red darken-2">
        <template dense v-slot:activator>
          <v-list-item dense class="ml-0 pl-0">
            <v-list-item-title color="red lighten-1">Funcionários</v-list-item-title>
          </v-list-item>
        </template>

        <v-list dense nav class="ml-5 pl-5">
          <v-list-item link :to="{ name: 'list_employees' }" color="red lighten-1">
            <v-list-item-icon>
              <v-icon>mdi-account-group</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Listar todos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link :to="{ name: 'employee_paycheck' }" color="red lighten-1">
            <v-list-item-icon>
              <v-icon>mdi-file-chart</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title :class="activeLinkText">Contracheque</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link :to="{ name: 'scales' }" color="red lighten-1">
            <v-list-item-icon>
              <v-icon>mdi-calendar-range</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title :class="activeLinkText">Escalas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link :to="{ name: 'income_tax' }" color="red lighten-1">
            <v-list-item-icon>
              <v-icon>mdi-currency-usd</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title :class="activeLinkText">Imposto de Renda</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list-group>
      <v-divider></v-divider>

      <v-list-group prepend-icon="mdi-message-bulleted" color="red darken-2">
        <template dense v-slot:activator>
          <v-list-item dense class="ml-0 pl-0">
            <v-list-item-title color="red lighten-1">Comunicação Interna</v-list-item-title>
          </v-list-item>
        </template>

        <v-list dense nav class="ml-5 pl-5">
          <v-list-item link :to="{ name: 'ci_received' }" color="red lighten-1">
            <v-list-item-icon>
              <v-icon>mdi-email</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Recebidos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link :to="{ name: 'ci_sended' }" color="red lighten-1">
            <v-list-item-icon>
              <v-icon>mdi-send</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Enviados</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link :to="{ name: 'ci_all' }" color="red lighten-1">
            <v-list-item-icon>
              <v-icon>mdi-view-list</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Todas as CI's</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list-group>
      <!-- <v-divider></v-divider>

        <v-list-group prepend-icon="mdi-clipboard-account">
            <template dense v-slot:activator>
                <v-list-item dense class="ml-0 pl-0 pr-0 mr-0">
                 <v-list-item-title>Trabalhe Conosco</v-list-item-title>
                </v-list-item>
            </template>
            <v-list dense nav sub-group class="ml-5 pl-5">
                <v-list-item link to="/" sub-group>
                    <v-list-item-icon>
                        <v-icon>mdi-clipboard-text</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>Nova Vaga</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-list dense nav sub-group class="ml-5 pl-5">
                <v-list-item link to="/" sub-group>
                    <v-list-item-icon>
                        <v-icon>mdi-clipboard-alert</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>Vagas em Aberto</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-list dense nav sub-group class="ml-5 pl-5">
                <v-list-item link to="/" sub-group>
                    <v-list-item-icon>
                        <v-icon>mdi-account-star</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>Banco de Talentos</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-list-group> -->

      <v-divider></v-divider>

      <v-list dense nav>
        <v-list-item link to="/">
          <v-list-item-icon>
            <v-icon>mdi-email-multiple</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Fale Conosco</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <template v-slot:append>
        <div class="pa-2">
          <v-btn class="menu-bg-gradinte-iph-red white--text" block @click="ActionSignOut"
            >Sair</v-btn
          >
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import IphLogo from './IphLogo'
import AvatarUser from './AvatarUser'

import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  name: 'MainMenu',
  data: function () {
    return {
      verify: true,
      inset: false,
      model: 0,
      menuRh: false,
      menuComunication: false,
      menuEcommerce: false,
      menuCourse: false,
      menuUsers: false,
      activeEmploeeMenu: true,
      activeLinkText: '',
      // activeCurrentPage: 'router-link-active',
      admins: [
        ['Management', 'mdi-home'],
        ['Settings', 'mdi-home'],
      ],
      cruds: [
        ['Create', 'add'],
        ['Read', 'insert_drive_file'],
        ['Update', 'update'],
        ['Delete', 'delete'],
      ],
    }
  },
  components: {
    IphLogo,
    AvatarUser,
  },
  computed: {
    ...mapState('menu', ['drawer']),
    ...mapGetters('auth', ['GET_user']),
  },
  methods: {
    ...mapActions('auth', ['ActionSignOut']),
    ...mapActions('menu', ['ActionSetDrawerFalse', 'ActionSetDrawerTrue']),
    ShowEvent(e) {
      let a = e.propertyName
      if (a == 'visibility' && this.verify) {
        this.ActionSetDrawerFalse()
        this.verify = false
      } else if (a == 'visibility' && !this.verify) {
        this.ActionSetDrawerTrue()
        this.verify = true
      }
    },
  },
}
</script>
